// #### Recipes ####
export const IoMRequestRecipe = {
    $type$: 'Recipe',
    name: 'IoMRequest',
    rule: [
        {
            itemprop: 'timestamp',
            itemtype: { type: 'number' }
        },
        {
            itemprop: 'initiator',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) }
        },
        {
            itemprop: 'mainId',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) }
        },
        {
            itemprop: 'alternateId',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) }
        },
        {
            itemprop: 'mode',
            itemtype: { type: 'string', regexp: /^(full|light)$/ }
        }
    ]
};
export default [IoMRequestRecipe];
//# sourceMappingURL=IoMRequest.js.map